import { Component } from '@angular/core';

@Component({
  selector: 'app-pat-payment-panel-stripe-cb',
  templateUrl: './pat-payment-panel-stripe-cb.component.html',
})
export class PatPaymentPanelStripeCbComponent {}
